import { SHOWROOM_ABOUT_US, SHOWROOM_PRIVACY_POLICY, SHOWROOM_TERMS_AND_CONDITIONS } from "./routesConstant";

export const SETTING_PAGE_OPTIONS = {
  SITEMAP: "Sitemap",
  MY_PAYMENTS: "my-payments",
  STORE_POLICY: "store-policy",
  SUGGESTION: "submit-suggestion",
  MY_INVOICES: "my-invoices",
  HELP: "help",
  CONTACT_US: "conatct-us",
};

export const SETTING_PAGE_SUBROUTES = {
  CONTROLS: "/settings/controls",
  PRODUCT_DISPLAY: "/settings/product-display",
  PROFILE: "/settings/profile",
  DELIVERY: "/settings/delivery",
  PAYMENTS: "/settings/payments",
  ORDERS: "/settings/orders",
  CUSTOMER: "/settings/customer",
  STAFF: "/settings/staff",
  STORE_POLICIES: "/settings/store-policies",
  HELP_CENTER: `${process.env.REACT_APP_DIGITALSHOWROOM_URL}help-section`,
  SUGGEST_IDEA: "/submit-suggestion",
  CONTACT_US: "/contact-us",
  OTHERS: "/settings/others",
  QUOTES: "/settings/quotes",
  ABOUT_US: SHOWROOM_ABOUT_US,
  PRIVACY_POLICY: SHOWROOM_PRIVACY_POLICY,
  TERMS_CONDITIONS: SHOWROOM_TERMS_AND_CONDITIONS,
};
